import { render, staticRenderFns } from "./BaseBlockChip.vue?vue&type=template&id=3e0d70b7&scoped=true"
import script from "./BaseBlockChip.vue?vue&type=script&lang=js"
export * from "./BaseBlockChip.vue?vue&type=script&lang=js"
import style0 from "./BaseBlockChip.vue?vue&type=style&index=0&id=3e0d70b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0d70b7",
  null
  
)

export default component.exports